import React from 'react'
import styles from "./stepIntoKriha.module.scss";
// import CommonQuestions from '../commonQuestions/CommonQuestions';
import HoverTile from '../hoverTile/HoverTile';

const data = [
  {id:1, question:"How does KrihaMegam reduce cloud costs?", answer: "A domain is your unique identity on the internet. It helps user to find out your website or application easily."},
  {id:2, question:"Can I migrate my existing cloud setup to KrihaMegam’s optimized infra ?", answer: "A domain is your unique identity on the internet. It helps user to find out your website or application easily."},
  {id:3, question:"How much can I save by switching to Krihamegam’s cost-optimized solutions?", answer: "A domain is your unique identity on the internet. It helps user to find out your website or application easily."},
  {id:4, question:"What cloud providers does KrihaMegam support for optimization?", answer: "A domain is your unique identity on the internet. It helps user to find out your website or application easily."},
]

const StepIntoKriha = () => {
  return (
     <div className={styles.container}>
        <div className={styles.wrapper}>
            <div className={styles.top}>
                <div className={styles.title}>STEP INTO THE</div>
                <div className={styles.subTitle}>WORLD OF KRIHA</div>
            </div>
            <div className={styles.bottom}>
                <HoverTile hoverData = {data}/>
            </div>
        </div>
    </div>
  )
}

export default StepIntoKriha